import VSelect from 'vue-select';
import Error from 'custom-error';
import { createPopper } from '@popperjs/core';

//
var script = {
  name: "CustomDropDown",
  components: {
    Error,
    VSelect
  },
  props: {
    id: {
      type: String,
      default: () => "",
      meta: {
        description: "Id del Componente CustomDropDown",
        example: "IdCustomDropDown"
      }
    },
    options: {
      type: Array,
      default: function () {
        return [];
      },
      meta: {
        description: "Posibilita elegir entre varias",
        example: '"[4, 8, 15, 16, 23, 42]'
      }
    },
    value: {
      type: [Object, Number, String],
      default: () => {},
      meta: {
        description: "Parámetro de entrada del CustomDropDown",
        example: "Texto requerido"
      }
    },
    label: {
      type: String,
      default: "",
      meta: {
        description: "Control para mostrar texto",
        example: "Texto requerido"
      }
    },
    prefixText: {
      type: String,
      default: "",
      meta: {
        description: "Establece, texto de prefijo",
        example: "Texto requerido"
      }
    },
    fieldkey: {
      type: String,
      required: true,
      meta: {
        description: "Establece, clave de campo",
        example: "id"
      }
    },
    fieldname: {
      type: String,
      required: true,
      meta: {
        description: "Estable el nombre del campo",
        example: "name"
      }
    },
    placeholder: {
      type: String,
      default: "",
      meta: {
        description: "Texto de referencia para el CustomDropDown",
        example: "Seleccione"
      }
    },
    required: {
      type: String,
      default: function () {
        return "";
      },
      meta: {
        description: "Estado requerido",
        example: "Texto requerido"
      }
    },
    error: {
      type: String,
      default: "",
      meta: {
        description: "Estado Error",
        example: "Texto requerido"
      }
    },
    disabled: {
      type: Boolean,
      required: false,
      meta: {
        description: "Estado Disabled",
        example: "true"
      }
    },
    customErrorMsg: {
      type: String,
      default: function () {
        return this.error;
      },
      meta: {
        description: "Mensaje de error encontrado",
        example: "Texto requerido"
      }
    },
    onSelectionChange: {
      type: Function,
      default: function () {},
      meta: {
        description: "Establece cambio de selección",
        example: "(value) => { return value.toUpperCase() }"
      }
    },
    reduce: {
      type: Function,
      default: undefined,
      meta: {
        description: "Funcion para escoger propiedad de opcion seleccionada",
        example: "(o) => o.id "
      }
    },
    objectkey: {
      type: [String, Number],
      default: null
    },
    clearable: {
      type: Boolean,
      default: () => true,
      meta: {
        description: "Estado que limpia en el contenedor",
        example: "True"
      }
    },
    regularLabel: {
      type: Boolean,
      default: () => false,
      meta: {
        description: "Control para mostrar texto en regular",
        example: "true"
      }
    },
    placementTop: {
      type: Boolean,
      default: () => false,
      meta: {
        description: "Establece posicionamiento superior.",
        example: "true"
      }
    },
    boldPlaceholder: {
      type: Boolean,
      default: () => false
    },
    isBold: {
      type: Boolean,
      required: false,
      default: () => false,
      meta: {
        description: "Clases para el dropdown",
        example: "true"
      }
    }
  },
  computed: {
    placement() {
      return "top";
    },

    valueText() {
      let text = "";

      if (this.value) {
        if (this.value[this.fieldname]) text = this.value[this.fieldname];else if (this.value[this.fieldkey] != null && this.value[this.fieldkey] != undefined && this.options.length > 0) {
          let option = this.options.find(x => x[this.fieldkey] == this.value[this.fieldkey]);
          text = option[this.fieldname];
        }
      }

      return text;
    },

    isDisabled() {
      return this.disabled || (this.value != null && this.value != undefined ? this.value.disabled != undefined ? this.value.disabled : this.disabled : this.disabled);
    }

  },
  methods: {
    updateValue(value) {
      this.onSelectionChange();
      this.$emit("input", value);
    },

    withPopper(dropdownList, component, {
      width
    }) {
      dropdownList.style.width = width;
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: this.placement,
        modifiers: [{
          name: "offset",
          options: {
            offset: [0, -1]
          }
        }, {
          name: "toggleClass",
          enabled: true,
          phase: "write",

          fn({
            state
          }) {
            component.$el.classList.toggle("drop-up", state.placement === "top");
          }

        }]
      });
      return () => popper.destroy();
    }

  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['custom-ddl', {
      'bold-ddl': _vm.isBold
    }]
  }, [_vm.label ? _c('label', {
    staticClass: "data-name",
    class: {
      regular: _vm.regularLabel
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('div', [_c('VSelect', {
    key: _vm.objectkey,
    staticClass: "custom-v-select",
    class: {
      'was-Invalidated': _vm.error,
      'bold-placeholder': _vm.boldPlaceholder
    },
    attrs: {
      "id": _vm.id,
      "label": _vm.fieldname,
      "options": _vm.options,
      "value": _vm.value ? _vm.prefixText + _vm.value[_vm.fieldname] : _vm.prefixText,
      "disabled": _vm.isDisabled || (_vm.value != null && _vm.value['disabled'] != undefined ? _vm.value['disabled'] : false),
      "clearable": _vm.clearable,
      "placeholder": _vm.placeholder,
      "reduce": _vm.reduce,
      "append-to-body": _vm.placementTop,
      "calculate-position": _vm.placementTop ? _vm.withPopper : function () {}
    },
    on: {
      "input": _vm.updateValue
    }
  }, [[_c('input', {
    staticClass: "vs__search",
    attrs: {
      "required": _vm.required
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event.target.value);
      }
    }
  })]], 2)], 1), _vm._v(" "), _vm.error ? _c('Error', {
    attrs: {
      "variant": "no-border",
      "message": _vm.customErrorMsg
    }
  }) : _vm._e()], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-17e9c273_0", {
    source: "span.invalid[data-v-17e9c273]:not(input){color:#e85c5c}.input-label[data-v-17e9c273]{height:19px;text-align:left;font:14px Lato;letter-spacing:0;color:#727272;line-height:19px}.input-label.regular[data-v-17e9c273]{font-weight:400}.custom-ddl div .v-select .vs__dropdown-toggle[data-v-17e9c273]{background:#fff 0 0 no-repeat padding-box;border:2px solid #c5cdcf;opacity:1;height:38px}.custom-ddl .vs__dropdown-menu[data-v-17e9c273]{background:#fff;border:none;position:relative}.custom-ddl .vs__search[data-v-17e9c273]::placeholder,.custom-ddl[data-v-17e9c273] :placeholder-shown{color:#495057;opacity:.8;line-height:1.6}.bold-ddl .vs__search[data-v-17e9c273]::placeholder,.bold-ddl[data-v-17e9c273] :placeholder-shown{color:#000;font-weight:700;line-height:1.6}.custom-ddl .vs__dropdown-menu .vs__dropdown-option[data-v-17e9c273],.custom-ddl .vs__selected-options .vs__selected[data-v-17e9c273],.custom-ddl span.vs__selected[data-v-17e9c273]{font-weight:400!important}.custom-ddl .was-Invalidated[data-v-17e9c273]{border-radius:4px;border:1px solid #ff0018}.custom-error i[data-v-17e9c273]{float:left;margin-top:15px;margin-right:10px;color:#e85c5c}.v-select.custom-v-select[data-v-17e9c273]{background-color:#fff}.v-select.custom-v-select.was-Invalidated[data-v-17e9c273]{background-color:#f7d7da}.v-select.custom-v-select[data-v-17e9c273] .vs__open-indicator{cursor:pointer}.custom-ddl[data-v-17e9c273] .v-select.drop-up.vs--open .vs__dropdown-toggle{border-radius:0 0 4px 4px;border-top-color:transparent;border-bottom-color:rgba(60,60,60,.26)}.custom-v-select[data-v-17e9c273] {background:#fff!important}.custom-v-select[data-v-17e9c273]  .vs__dropdown-menu{width:auto!important;min-width:100%!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__ = "data-v-17e9c273";
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

// Import vue component

const install = function installCustomDropDown(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('CustomDropDown', __vue_component__);
}; // Create module definition for Vue.use()
// to be registered via Vue.use() as well as Vue.component()


__vue_component__.install = install; // Export component by default
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export default __vue_component__;
